import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { Col, Grid, Row, styled, th, up } from '@smooth-ui/core-sc';
import Helmet from 'react-helmet';

import VideoEmbed from '../../components/VideoEmbed/VideoEmbed';

import { withSettings } from '../../containers/WebApp/SettingsContext';
import PrivateComponent from '_platform/src/utils/PrivateComponent';
import getLoginPath from '_platform/src/utils/getLoginPath';

import PagesImg from './images/pages.png';

import HowBoxFooter from './images/how-box-footer.png';
import SubmitImg from './images/submit.svg';
import EarnImg from '../../components/StatementLoyalty/images/balance.svg';
import RedeemImg from './images/redeem.svg';

import PinkBoxImg from './images/pink-box-hover.png';
import PinkBoxHoverImg from './images/pink-box.png';
import BlueBoxImg from './images/blue-box-hover.png';
import BlueBoxHoverImg from './images/blue-box.png';
import OrangeBoxImg from './images/orange-box-hover.png';
import OrangeBoxHoverImg from './images/orange-box.png';

import Button from '_platform/src/components/Button/Button';

import { Link, useLocation } from 'react-router-dom';

import LoadAsync from '_platform/src/utils/LoadAsync';
const InvoiceProvider = LoadAsync(() =>
  import(
    /* webpackChunkName: "invoiceProvider" */ 'containers/InvoiceProvider/InvoiceProvider'
  )
);
const InvoiceForm = LoadAsync(() =>
  import(
    /* webpackChunkName: "invoiceForm" */ 'containers/InvoicePage/InvoiceForm'
  )
);

const PageContainer = styled.div`
  background-image: url(${PagesImg});
  background-repeat: no-repeat;
  background-position: top center;

  h2,
  h3 {
    text-transform: uppercase;
  }

  .jump-to-submit-button {
    width: 90%;
  }
`;

const AlternateContainer = styled.div`
  background-color: ${th('primary')};
  color: white;
  padding: 2em 0;
  text-align: center;

  a {
    color: white;
  }

  h1 {
    font-weight: normal;
  }
  p {
    line-height: 1.5;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  ${up('sm')} {
    justify-content: center;
    align-items: stretch;
    flex-direction: row;
  }

  .link--paper {
    width: 285px;
    height: 287px;
    padding: 30px;
    text-decoration: none;
    color: black;
    text-align: right;
    font-size: 35px;
    text-transform: uppercase;
    font-weight: bold;
    line-height: 1.2;
    background-size: contain;
  }

  .link--paper1 {
    background-image: url(${OrangeBoxImg});
    &:hover,
    &:focus {
      background-image: url(${OrangeBoxHoverImg});
    }
  }

  .link--paper2 {
    background-image: url(${PinkBoxImg});
    &:hover,
    &:focus {
      background-image: url(${PinkBoxHoverImg});
    }
  }

  .link--paper3 {
    background-image: url(${BlueBoxImg});
    &:hover,
    &:focus {
      background-image: url(${BlueBoxHoverImg});
    }
  }
`;

const HowToStep = styled.div`
  width: 285px;
  margin: 10px;
  color: white;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .howtostep__content {
    padding: 18px;
    padding-bottom: 0;
    background-color: ${th('primary')};
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .howtostep__image {
    display: flex;
    justify-content: center;
    max-width: 105px;
    height: 90px;
    justify-content: flex-start;
    img {
      display: block;
    }
  }
  .howtostep__text {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-start;
  }
  h3 {
    margin: 20px 0 10px;
    color: ${th('secondary')};
    text-transform: uppercase;
  }
  p {
  }
`;

const HomePage = ({ settings }) => {
  const submitClaimRef = React.useRef(null);
  const location = useLocation();
  const qrParam = new URLSearchParams(location.search).get('qr') || undefined;

  const scrollToSubmitClaim = () => {
    if (!submitClaimRef.current) return;
    const scrollEl = document.scrollingElement || document.documentElement;
    const start = scrollEl.scrollTop;
    const target = submitClaimRef.current.getBoundingClientRect().top + start;
    const distance = target - start;
    const duration = 600;
    let startTime = null;
    const ease = t => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
    const step = ts => {
      if (!startTime) startTime = ts;
      const p = Math.min((ts - startTime) / duration, 1);
      scrollEl.scrollTop = start + distance * ease(p);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  useEffect(() => {
    if (qrParam && submitClaimRef.current) {
      scrollToSubmitClaim();
    }
  }, [qrParam]);

  return (
    <PageContainer>
      <Helmet>
        {/* <meta name="description" content="Page description" /> */}
      </Helmet>

      <PrivateComponent redirectOnError={getLoginPath(settings.settingsApp)}>
        {/*<CodesWrapper>
          <Grid>
            <ThemeProvider
              theme={{
                inputPaddingY: `calc(.375rem - 1px)`,
                primary: '#f4bd19',
              }}
            >
              <CodesProvider
                disableMeta
                redeemLabels={{
                  button: 'Add your voucher',
                  input: 'Add more unique vouchers now',
                  placeholder: 'Unique voucher number',
                  successMessage:
                    'Success! Your voucher points have been applied.',
                  errorMessage:
                    "Uh-oh! We've encountered an error trying to apply your voucher. Check the voucher number and try again.",
                }}
                // show="list"
              />
            </ThemeProvider>
          </Grid>
        </CodesWrapper>*/}

        <Grid>
          <Row justifyContent="center">
            <Col md={10}>
              <div className="spacer--top">
                <VideoEmbed
                  videoId="R1Rwr2qZN2w"
                  title="Ream Rewards Program Overview"
                />
              </div>
              <div className="text--center">
                <div className="spacer">
                  <Button
                    className="jump-to-submit-button"
                    onClick={scrollToSubmitClaim}
                  >
                    Submit A Claim
                  </Button>
                </div>
                <h1 className="h2">Welcome To Double A Ream Rewards</h1>
                <p>
                  Earn points for your purchases by submitting a unique code
                  found inside cartons of{' '}
                  <a
                    href="https://doubleapaper.com/au-en/double-a-paper/a4/double-a-premium-80-gsm-a4-au"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Double A 80gsm A4 Copy Paper 5 Ream
                  </a>
                  . There’s no limit to the amount of points you can earn, PLUS,
                  every unique code submitted gives you an entry into the{' '}
                  <Link to="/prizes">Quarterly Prize Draw</Link> where you have
                  the chance to win some fantastic prizes!{' '}
                </p>
                <hr />
                <h2>​How To Submit Your Claim</h2>
                <p>
                  Every time you buy a specially marked Double A 80gsm A4 Copy
                  Paper 5 Ream carton, scan the QR code under the lid of the box
                  or manually enter the unique code to submit your claim for
                  approval. Once validated, you will earn 150 points for every
                  code submitted and earn 1 entry in the next Quarterly Prize
                  Draw.
                </p>
                <p>
                  Ensure you are logged in to the Program Website and when you
                  scan each QR code under the lid, the code will populate (or
                  you can enter manually). Then simply submit your claim and
                  watch your points balance grow and your Prize Draw entries
                  rise!
                </p>
              </div>
            </Col>
          </Row>
        </Grid>

        <Grid>
          <Row justifyContent="center">
            <Col>
              <FlexContainer className="spacer--bottom">
                <HowToStep>
                  <div className="howtostep__content">
                    <div className="howtostep__image">
                      <img src={SubmitImg} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>Submit</h3>
                      <p className="text--tight">
                        Scan or enter your eligible Unique Product Code claim
                        for validation
                      </p>
                    </div>
                  </div>
                  <img src={HowBoxFooter} alt="" />
                </HowToStep>
                <HowToStep>
                  <div className="howtostep__content">
                    <div className="howtostep__image">
                      <img src={EarnImg} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>Earn</h3>
                      <p className="text--tight">
                        Following validation, receive points in your Double A
                        Ream Rewards Account
                      </p>
                    </div>
                  </div>
                  <img src={HowBoxFooter} alt="" />
                </HowToStep>
                <HowToStep>
                  <div className="howtostep__content">
                    <div className="howtostep__image">
                      <img src={RedeemImg} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>Redeem</h3>
                      <p className="text--tight">
                        Redeem your points against a wide range of rewards!
                      </p>
                    </div>
                  </div>
                  <img src={HowBoxFooter} alt="" />
                </HowToStep>
              </FlexContainer>
            </Col>
          </Row>
        </Grid>

        <AlternateContainer ref={submitClaimRef}>
          <Grid>
            <Row justifyContent="center">
              <Col md={8}>
                <div>
                  <h3>
                    <u>Submit a claim</u>
                  </h3>

                  <InvoiceProvider
                    render={({
                      clients,
                      products,
                      onInvoiceSubmit,
                      status,
                    }) => (
                      <div>
                        <InvoiceForm
                          onSubmitForm={onInvoiceSubmit}
                          status={status}
                          clients={clients}
                          products={products}
                          initialValues={
                            qrParam
                              ? { invoiceProducts: [{ serialNumber: qrParam }] }
                              : undefined
                          }
                        />
                      </div>
                    )}
                  />

                  <small>
                    <b>Please Note:</b> Unique Codes can only be entered once,
                    any Unique Codes entered more than once will be rejected.
                    You will be able to see a summary of all your submitted and
                    approved Unique Code submissions via the My Activity page.
                    Plus, look out for emails advising of bonus opportunities to
                    boost your points balance and Quarterly Prize Draw entries!
                    Check out the rewards you can redeem your points for{' '}
                    <Link to="/rewards/">here</Link>! You'll be selecting the
                    reward of your choice in no time!
                  </small>
                </div>
              </Col>
            </Row>
          </Grid>
        </AlternateContainer>

        <Grid className="spacer--top">
          <Row className="spacer" justifyContent="center">
            <Col>
              <FlexContainer>
                <Link className="link--paper link--paper1" to="/my-activity/">
                  View Your Points
                </Link>
                <Link className="link--paper link--paper2" to="/rewards/">
                  Rewards Catalogue
                </Link>
                <Link className="link--paper link--paper3" to="/prizes/">
                  Quarterly Prizes Up For Grabs
                </Link>
              </FlexContainer>
            </Col>
          </Row>
        </Grid>
      </PrivateComponent>
    </PageContainer>
  );
};

HomePage.propTypes = {
  settings: PropTypes.object.isRequired,
};

export default withSettings(HomePage);
